import { Options } from '../../Options'
import { ChartLineConstants } from '../ChartLine/ChartLine.constants'

export const chartMarkOptions = Options.asRecord(
  Options.createOption({
    key: 'lineWidth',
    inputKind: 'number',
    defaultValue: ChartLineConstants.defaultLineWidth,
    min: 1,
    max: 8,
    step: 1,
    label: 'Line width',
    description: 'Stroke width of a line or reference mark.',
    category: 'Mark',
  }),
  Options.createOption({
    key: 'lineStyle',
    inputKind: 'select',
    selectChoices: [
      { value: 'solid', label: 'Solid' },
      { value: 'dashed', label: 'Dashed' },
      { value: 'dotted', label: 'Dotted' },
    ],
    defaultValue: ChartLineConstants.defaultLineStyle,
    label: 'Line style',
    description: 'Stroke dash pattern for a line or reference mark.',
    category: 'Mark',
  }),
)

export type ChartMarkOptions = Options.TypeOf<typeof chartMarkOptions>
export type ChartLineStyle = Options.ResolvedTypeOf<
  typeof chartMarkOptions
>['lineStyle']
